import { MutationTree } from 'vuex';
import { AxiosError } from 'axios';
import {
  ActivateOrderResponse, Basket, CheckoutData, OrderState,
} from './types';
import { getDefaultErrorState, getDefaultLoadingState, getDefaultState } from '../utils';
import { MutationRequestStatus } from '../types';

export const mutations: MutationTree<OrderState> = {
  basketLoading: (state) => state.basket = { ...getDefaultLoadingState() },
  basketError: (state) => state.basket = { ...getDefaultErrorState() },
  basketLoaded(state, payload: CheckoutData) {
    payload.basket.preorder = new Date(payload.basket.preorder);

    state.basket = {
      error: undefined,
      status: MutationRequestStatus.SUCCESS,
      data: payload,
    };
  },
  productError(state) {
    state.basket = { ...getDefaultErrorState() };
  },

  activateOrderLoading: (state) => state.order = { ...getDefaultLoadingState() },
  activateOrderLoaded: (state, payload: ActivateOrderResponse) => state.order = {
    error: undefined,
    status: MutationRequestStatus.SUCCESS,
    data: payload,
  },
  activateOrderError: (state, error: AxiosError) => {
    state.order = {
      ...getDefaultErrorState(),
      error: {
        code: error.response.status,
        message: error.response.data.message,
        data: error.response.data,
      },
    };
  },

  activateOrderLaterLoading: (state) => state.orderLater = { ...getDefaultLoadingState() },
  activateOrderLaterLoaded: (state) => state.orderLater = {
    error: undefined,
    status: MutationRequestStatus.SUCCESS,
    data: undefined,
  },
  activateOrderLaterError: (state, error: AxiosError) => {
    state.orderLater = {
      ...getDefaultErrorState(),
      error: {
        code: error.response.status,
        message: error.response.data.message,
        data: error.response.data,
      },
    };
  },
};
